const locales = {
  en: 'en',
  ru: 'ru'
}

import defaultLocale from '@/locales/ru.js'

export default {
  state: {
    i18n: defaultLocale,
    activeLocale: locales.ru,
    locales: locales
  },
  getters: {
    i18n: state => state.i18n,
    i18nActiveLocale: state => state.activeLocale,
    i18nLocales: state => state.locales // const variants of locales
  },
  mutations: {
    // практически это почти только для внутреннего использования. используйте вместо этого action i18nSetLocale
    i18nSet (state, newActiveLocale, newI18nObj) {
      state.activeLocale = newActiveLocale
      state.i18n = newI18nObj
    }
  },
  actions: {
    // используйте по коду компонент следующее: this.i18nSetLocale(this.i18nLocales.ru)
    i18nSetLocale ({ commit }, newActiveLocale) {
      var locale = () => import('@/locales/' + newActiveLocale + '.js')
      locale().then((newI18nObj) => { commit('i18nSet', newActiveLocale, newI18nObj) })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/storeI18n.js